'use es6';

import { connect } from 'react-redux';
import CommonMessage from 'conversations-visitor-message-history/common-message/CommonMessage';
import { isStarted } from '../../../threads/operators/isStarted';
import { publishVisitorMessage } from '../../../pubsub/actions/publishVisitorMessage';
import { hasUnansweredQuickReplyMessage } from '../../../selectors/chatSelectors';
import { getSelectedThread } from '../../../selected-thread/selectors/getSelectedThread';
import { toggleOpen } from '../../../actions/WidgetActions';
import { getIsMobile } from '../../../selectors/getIsMobile';
import { getWidgetDataLanguage, getIsUngatedForSpeechPoc, getIsUngatedForInlineCitations } from '../../../widget-data/selectors/widgetDataSelectors';
import { trackInteraction } from '../../../usage-tracking/actions/trackInteraction';
import { navigateToKnowledgeBaseArticle } from '../../../navigation/actions/navigateToKnowledgeBaseArticle';
import { withBrowserSizeContext } from '../../../containers/withBrowserSizeContext';
import { getFilteredMessages } from '../../selectors/getFilteredMessages';
import { getColoring } from '../../../selectors/widgetDataSelectors/getColoring';
import { postQuickLinkButtonClickEvent } from '../../../pubsub/actions/postQuickLinkButtonClickEvent';
const mapStateToProps = state => {
  var _state$speechPoc, _state$speechPoc2;
  const selectedThread = getSelectedThread(state);
  const coloring = getColoring(state);
  return {
    hasUnansweredQuickReplyMessage: hasUnansweredQuickReplyMessage(state, {
      thread: selectedThread
    }),
    isThreadStarted: isStarted(selectedThread),
    mobile: getIsMobile(state),
    locale: getWidgetDataLanguage(state),
    messagesList: getFilteredMessages(state),
    speechPocActive: getIsUngatedForSpeechPoc(state) && ((_state$speechPoc = state.speechPoc) === null || _state$speechPoc === void 0 ? void 0 : _state$speechPoc.speechPocActive),
    audioPlaybackStatus: (_state$speechPoc2 = state.speechPoc) === null || _state$speechPoc2 === void 0 ? void 0 : _state$speechPoc2.audioPlaybackStatus,
    accentColor: coloring.accentColor,
    isUngatedForInlineCitations: getIsUngatedForInlineCitations(state)
  };
};
const mapDispatchToProps = {
  navigateToKnowledgeBaseArticle,
  publishMessage: publishVisitorMessage,
  toggleOpen,
  trackInteraction,
  onQuickLinkClick: postQuickLinkButtonClickEvent
};
export default connect(mapStateToProps, mapDispatchToProps)(withBrowserSizeContext(CommonMessage));